"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var content = function content() {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("width:186px;font-size:16px;line-height:20px;text-align:center;")
  );
};

var _default = {
  content: content
};
exports.default = _default;